import { render, staticRenderFns } from "./EmailAddressBook.vue?vue&type=template&id=3ba70c88"
import script from "./EmailAddressBook.vue?vue&type=script&lang=js"
export * from "./EmailAddressBook.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports